/**
 * Fiche de l'organisation : l'éditeur du site (identité, localisation, accès et services, médias).
 * Les équipements ont leur section du menu (EquipementsPage) ; la tarification est dans Refuges et
 * campings ; l'inventaire prêt-à-camper (résumé importé de CampingQuébec) n'y est pas modifiable.
 * Les onglets suivent l'ancre (#medias, #acces…). Localisation : une seule carte (accueil + périmètre).
 */
import { OrganizationSettings } from '@web/features/organizations/components/OrganizationSettings'
import '@web/features/organizations/styles/OrganizationEditPage.css'
import { BoundaryEditor } from '../components/BoundaryEditor'
import { useOrg } from '../utils/orgContext'

export function FichePage() {
  const { orgId } = useOrg()
  return (
    <div className="g-page g-page--wide g-embed">
      <OrganizationSettings
        organizationId={orgId}
        hiddenTabs={['facilities', 'pricing']}
        hideLodgingUnits
        // Une seule carte pour la localisation : point d'accueil et périmètre (plan ou satellite).
        renderLocationMap={({ point, onPointChange, disabled }) => (
          <BoundaryEditor orgId={orgId} point={point} onPointChange={onPointChange} pointDisabled={disabled} />
        )}
      />
    </div>
  )
}
